import { Component, inject, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { SpaRouteTrackerService } from "@weps/shared-analytics";

/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: "app-root",
  standalone: false,
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
/* eslint-enable @angular-eslint/prefer-standalone */
export class AppComponent implements OnInit {
  protected readonly appCode = "ROB";
  isGuidedFlow: boolean = false;
  isUnauthorized: boolean = false;

  private readonly spaRouteTracker = inject(SpaRouteTrackerService);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.spaRouteTracker.initialize();
    // WebLogger.init() is now called in main.ts before Angular bootstraps
    // to ensure it's available for web-vitals callbacks and early logging

    // Note: Baggage initialization moved to APP_INITIALIZER in app.module.ts
    // to ensure it runs before any HTTP requests are made

    this.route.queryParams.subscribe((params) => {
      this.isUnauthorized = params["errorCode"] === "401";
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isGuidedFlow = event.urlAfterRedirects.includes("guided-flow");
      }
    });
  }
}
